export const exportToCsv = (filename, rows, columns) => {
  const header = columns.map((c) => c.header).join(",");
  const csvRows = rows.map((row) =>
    columns
      .map((c) => {
        const val = typeof c.accessor === "function" ? c.accessor(row) : row[c.accessor];
        const str = String(val ?? "").replace(/"/g, '""');
        return `"${str}"`;
      })
      .join(",")
  );
  const csv = [header, ...csvRows].join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
